import { Editor, Range } from '@tiptap/react'
import { Level } from '@tiptap/extension-heading'

import { MenuKey } from './ContextualMenu.decl'

export const KEYS: MenuKey[] = ['ArrowUp', 'ArrowDown', 'Enter']

type MenuKeysPressCallbacks = { [key in MenuKey]?: () => void }
/**
 * Upon pressing a MenuKey, fire corresponding callback.
 * @param e KeyboardEvent.
 * @param callbacks the callbacks specified in an object, by MenuKey.
 */
export const onMainKeysPress = (
  e: KeyboardEvent,
  callbacks: MenuKeysPressCallbacks
) => {
  const keyPressed = e.key as MenuKey

  if (KEYS.includes(keyPressed)) {
    e.preventDefault()
    e.stopPropagation()
  }

  const callbackToFire = callbacks[keyPressed]

  if (!!callbackToFire) {
    callbackToFire()
  }
}

export const setHeadingChain = (editor: Editor, range: Range, level: Level) => {
  const { from, to } = range
  const { node } = editor.view.domAtPos(from)

  const isLineEmpty = node.textContent?.trim() === '/'
  const chain = editor.chain().deleteRange({ from, to })

  if (isLineEmpty) {
    chain.setHeading({ level }).focus().run()
  } else {
    chain
      .insertContentAt(from, {
        type: 'heading',
        attrs: { level },
      })
      .focus()
      .run()
  }
}
